import logo from '../../assets/Avatars.svg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export const testimonials = [
    {
      text: "When my team of 4 was downsized to 1, Datascient came to the rescue. Datascient helps us manage our entire internal marketing calendar in one place and creates content for our DEI initiatives.",
      author: 'Chief Diversity Officer',
      position: 'F500 IT Services company',
      icon: logo,
    },
    {
      text: "We were competing for talent with Coinbase and Meta, but did not have the resources to market our promote our employer brand. Datascient helped us scale up our talent marketing efforts to the level of Meta at a fraction of the cost.",
      author: 'Head of Employer Branding',
      position: 'Hyper Growth Crypto Company',
      icon: logo,
    },
    {
      text: "Thanks to Datascient, crafting targeted campaigns for diverse candidate pools is now a breeze. What used to take months, from researching talent personas to competitor positioning, now only takes minutes, resulting in a remarkable 20% increase in our conversion rate within three months.",
      author: 'VP Talent Acquisition',
      position: 'Leading Staffing Company',
      icon: logo,
    },
    
  ];